<template>
  <div id="app">
    <AppHeader />
    <main>
      <AppHero />
      <AppAbout />
      <AppServices />
      <AppAdvantages />
      <AppContact />
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppHero from './components/AppHero.vue'
import AppAbout from './components/AppAbout.vue'
import AppServices from './components/AppServices.vue'
import AppAdvantages from './components/AppAdvantages.vue'
import AppContact from './components/AppContact.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppHero,
    AppAbout,
    AppServices,
    AppAdvantages,
    AppContact,
    AppFooter
  }
}
</script>

<style>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
  color: #333;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

section {
  scroll-margin-top: 100px;
}

/* Utility Classes */
.btn {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 1rem;
}

.btn-primary {
  background-color: #1E5AA8;
  color: white;
}

.btn-primary:hover {
  background-color: #0A2647;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(30, 90, 168, 0.3);
}

.btn-secondary {
  background-color: #4CAF50;
  color: white;
}

.btn-secondary:hover {
  background-color: #3d8b40;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
}

/* Responsive */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  
  .btn {
    padding: 10px 20px;
    font-size: 0.95rem;
  }
}
</style>
